
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';
import { useAuth } from '@/context/SupabaseAuthContext';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import CRMDashboard from '@/components/admin/crm/CRMDashboard';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const CRMPage = () => {
  const { user } = useAuth();
  const { handleLogout } = useAdminSettings();

  return (
    <AdminLayout onLogout={handleLogout} userRole={user?.role} activeTab="crm">
      <div className="container mx-auto p-6">
        <Card className="mb-8">
          <CardHeader>
            <CardTitle className="text-2xl">Customer Relationship Management</CardTitle>
            <CardDescription>Manage your referral users and communication campaigns</CardDescription>
          </CardHeader>
        </Card>
        
        <Routes>
          <Route path="/" element={<CRMDashboard />} />
          {/* Add more CRM related routes here as needed */}
        </Routes>
      </div>
    </AdminLayout>
  );
};

export default CRMPage;
